import { render, staticRenderFns } from "./ResetPasswordSuccessLoggedIn.vue?vue&type=template&id=3da170c2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports